module.exports = __webpack_public_path__ + "static/media/cart.ea47abc6.svg";